<div
  class="offer-card offer-card-body px-2 h-100 d-flex flex-column"
  [class.rounded-top-0]="isQuestionnaireVariant()"
  [class.border-top-0]="isQuestionnaireVariant()"
>
  @if (!showLoadingState) {
    <ng-content />
  }
  @if (showLoadingState) {
    <wl-svg-skeleton-loader [mask]="mask" />
  }
</div>
